module.exports = __webpack_public_path__ + "static/img/eyes_05.6af4e7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_05.png
// module id = nq8H
// module chunks = 0